import { EntityType, ResolvedEntity } from '@frontend/common';
import { accountIdFromResolvedEntity } from '@frontend/components/common';
import { ProductCategoryClient } from '@frontend/group/api';
import { GroupMember, IGroup } from '@frontend/group/types';
import { useModals } from '@frontend/modal';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { DefaultContainer } from '../../../modal/detail-modal/default-container/default-container';
import { PlatformObjectBadge } from '../../../modal/platform-object-badge/platform-object-badge.component';
import { LinkCategoriesModal } from '../product-detail-modal/link-categories-modal/link-categories-modal.component';

const ID = 'stock-product-categories-container';

interface CategoriesProps {
    categories?: ResolvedEntity[] | null;
    entity_id: string;
    entity_type: EntityType;
}

export const CategoriesContainer = (props: CategoriesProps) => {
    const { openModal } = useModals();
    const LINK_CATEGORIES_MODAL_ID = 'link-categories-modal';
    const [groups, setGroups] = useState<IGroup[]>([]);
    const [members, setMembers] = useState<GroupMember[]>([]);

    const fetchGroups = async () => {
        if (!props.categories?.length) {
            setMembers([]);
            setGroups([]);
            return;
        }

        setGroups(props.categories.map((cat) => ({ id: cat.entity_id }) as IGroup));
        ProductCategoryClient.fetchProductCategoryMembers({ entity_id: props.entity_id, group_id: props.categories.map((cat) => cat.entity_id) }).then(
            (members) => {
                setMembers(members.results);
            }
        );
    };

    useEffect(() => {
        fetchGroups();
    }, [props.entity_id]);

    return (
        <DefaultContainer
            key={ID}
            styles={{ container: 'w-64' }}
            title={
                <FormattedMessage
                    id='vendingProductCategories.categorie'
                    defaultMessage='Categories'
                    description='Message displayed as a title of the categorie list in the general tab of product in vending'
                />
            }
            update={{
                onUpdate: () =>
                    openModal(LINK_CATEGORIES_MODAL_ID, () => (
                        <LinkCategoriesModal
                            entity_type={props.entity_type}
                            entity_id={props.entity_id}
                            groups={groups}
                            members={members}
                        />
                    ))
            }}
            content={
                <div className='flex flex-col items-start justify-start gap-1'>
                    {props.categories ? (
                        props.categories.map((item) => (
                            <PlatformObjectBadge
                                key={item.entity_id}
                                display={item.name}
                                entityType={item.entity_type}
                                id={item.entity_id}
                                foreign={item.foreign}
                                accountId={accountIdFromResolvedEntity(item)}
                            />
                        ))
                    ) : (
                        <div></div>
                    )}
                </div>
            }
        />
    );
};
